import { connect } from 'dva';
import { Form } from 'antd';
import { compose, mapProps } from 'recompose';
import FormWorkflow from '~/routes/Workflows/form_workflow';

export default compose(
  connect(({ workflows, loading, errors }) => ({
    workflow: workflows.resource,
    loading: loading.effects['workflows/read'],
    submitting: loading.effects['workflows/update'],
    formErrors: errors.formErrors,
  })),
  Form.create(),
  mapProps(ownerProps => ({
    ...ownerProps,
    type: 'edit',
  })),
)(FormWorkflow);
